<umss-dialog
  [open]="open()"
  [size]="'Small'"
  [type]="'Modal'"
  [position]="'Center'"
  [backdrop]="true"
  [backdropClosable]="true"
  (onClose)="close()"
>
  <umss-dialog-header
    [title]="'Add Exception'"
    [showCloseButton]="true"
    (onClose)="close()"
  />

  <div class="dialog-body">
    @if (exceptionDate(); as date) {
      <p class="dialog-date">{{ date | date: 'MMMM d, y' }}</p>
    }

    <form [formGroup]="formGroup" class="dialog-form">
      <!-- Availability toggle -->
      <div class="form-field">
        <umss-label text="Availability" size="Regular" weight="Medium" />
        <umss-button-group
          requireSelection
          [formControl]="formGroup.controls.isUnavailable"
        >
          <umss-toggle-button label="Available" [value]="false" />
          <umss-toggle-button label="Unavailable" [value]="true" />
        </umss-button-group>
      </div>

      <!-- Time range — only shown when Available -->
      <div class="time-range-section" [class.hidden]="!isAvailable()">
        <umss-time-range-field [formGroup]="formGroup" />
      </div>

      <!-- Reason (vertical — label above textarea) -->
      <div class="form-field">
        <umss-label text="Reason" size="Regular" weight="Medium"></umss-label>
        <umss-textarea
          id="exception-reason-field"
          placeholder="Optional reason for this exception"
          [formControlName]="'reason'"
        />
      </div>
    </form>
  </div>

  <umss-dialog-footer
    [primaryButtonLabel]="'Save'"
    [secondaryButtonLabel]="'Cancel'"
    [primaryButtonVariant]="'Primary'"
    [buttonSize]="'Regular'"
    (onPrimaryClick)="save()"
    (onSecondaryClick)="close()"
  />
</umss-dialog>
